export const week = [
    {
        "desc": "Monday",
        "translation": "monday",
        "translationShort": "Mon",
        "id": 1,
        "style": "font-weight: 600;"
    },
    {
        "desc": "Tuesday",
        "translation": "tuesday",
        "translationShort": "Tue",
        "id": 2,
        "style": "font-weight: 600;"
    },
    {
        "desc": "Wednesday",
        "translation": "wednesday",
        "translationShort": "Wed",
        "id": 4,
        "style": "font-weight: 600;"
    },
    {
        "desc": "Thursday",
        "translation": "thursday",
        "translationShort": "Thu",
        "id": 8,
        "style": "font-weight: 600;"
    },
    {
        "desc": "Friday",
        "translation": "friday",
        "translationShort": "Fri",
        "id": 16,
        "style": "font-weight: 600;"
    },
    {
        "desc": "Saturday",
        "translation": "saturday",
        "translationShort": "Sat",
        "id": 32,
    },
    {
        "desc": "Sunday",
        "translation": "sunday",
        "translationShort": "Sun",
        "id": 64,
    },
    {
        "desc": "Holiday",
        "translation": "holiday",
        "translationShort": "Hol",
        "id": 128,
        "style": "color: #F00;"
    }
]